export interface StoryboardSlide {
  step: number
  title: string
  note: string
}

export const storyboard: StoryboardSlide[] = [
  {
    step: 0,
    title: 'What are you?',
    note: 'We open on the audience, not the products. One tap to place yourself in your own family — a question everyone already knows how to answer.',
  },
  {
    step: 1,
    title: 'Ah, the responsible one?',
    note: 'A playful interpretation of their answer. Agreeing or disagreeing both count — they are participating either way.',
  },
  {
    step: 2,
    title: 'Families are funny',
    note: 'The interlude that turns the human idea towards the portfolio. The world darkens into Solventum as the line lands.',
  },
  {
    step: 3,
    title: 'The family portrait',
    note: 'Three composites and one late arrival, together for the first time. Same heritage, different strengths.',
  },
  {
    step: 4,
    title: 'Meet the first sibling',
    note: 'A product, three traits, and a question: which sibling does that sound like? The audience works out the positioning itself.',
  },
  {
    step: 5,
    title: 'Meet the next sibling',
    note: 'Same format, different personality. The reveal confirms the association they just made.',
  },
  {
    step: 6,
    title: 'Meet the third sibling',
    note: 'The introduction order is shuffled every run, so no two plays open on the same sibling.',
  },
  {
    step: 7,
    title: 'The caboose child',
    note: 'And just when you thought you had met everyone — the Composite Warmer arrives late and changes the family dynamic.',
  },
  {
    step: 8,
    title: 'There is no best sibling',
    note: 'The strategic landing: different jobs, different strengths — and every case can run warm.',
  },
  {
    step: 9,
    title: 'Change the solution. Not the system.',
    note: 'The commercial message, and an invitation to meet the whole family again.',
  },
]
